import React from 'react';
import { useLast30DaysReleases } from '@hub/api/queries';
import OnboardingAssetsModalWrapper from '../components/onboarding-assets-modal/onboarding-assets-modal-wrapper';
import { ProfileApprovalModal } from '../components/profile-approval-modal/profile-approval-modal';
import { WhatsNewModal } from '../components/whats-new-modal/whats-new-modal';
import LiveChat from '../features/live-chat/live-chat';

const AuthenticatedExtras: React.FC = () => {
  const { data: releasesData } = useLast30DaysReleases();
  const releases = Array.isArray(releasesData) ? releasesData : [];
  return (
    <>
      <LiveChat />
      <ProfileApprovalModal />
      <OnboardingAssetsModalWrapper />
      <WhatsNewModal releases={releases} />
    </>
  );
};

export default AuthenticatedExtras;
